import { TimerOffOutlined, TimerOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import React from 'react';

type ChatSessionInactivityIndicatorProps = {
  enabled: boolean;
  label: string;
  tooltip: string;
  onLabel: string;
  offLabel: string;
};

const ChatSessionInactivityIndicator: React.FC<ChatSessionInactivityIndicatorProps> = ({
  enabled,
  label,
  tooltip,
  onLabel,
  offLabel
}) => {
  const title = `${label}: ${enabled ? onLabel : offLabel}. ${tooltip}`;

  return (
    <Tooltip title={title} arrow placement="top">
      <span
        className={`chatyme-session-inactivity-indicator${enabled ? ' chatyme-session-inactivity-indicator--on' : ' chatyme-session-inactivity-indicator--off'}`}
        aria-label={title}
      >
        {enabled ? <TimerOutlined fontSize="inherit" /> : <TimerOffOutlined fontSize="inherit" />}
      </span>
    </Tooltip>
  );
};

export default ChatSessionInactivityIndicator;
